export default "__VITE_ASSET__B33K1Oed__"